// Mục Điển Tịch (UI_SPEC §18.3; STORY §11.2). Chữ nằm trong i18n: `<id>.title`, `<id>.body`.
// Bản LK của mỗi mục; bản sau reveal thêm ở giai đoạn của nó.
import type { Phase } from '../screens';

export interface CodexEntryDef {
  readonly id: string;
  readonly phase: Phase;
}

export const CODEX_ENTRIES: readonly CodexEntryDef[] = [{ id: 'codex.lampSpirit', phase: 'P0' }];

export function isCodexId(v: unknown): v is string {
  return typeof v === 'string' && CODEX_ENTRIES.some((c) => c.id === v);
}
